import React from 'react'
import { Price, Token } from '@uniswap/sdk'
import { useContext } from 'react'
import { Repeat } from 'react-feather'
import { Text } from 'rebass'
import { ThemeContext } from 'styled-components'
import { useActiveWeb3React } from '../../hooks'
import { getCurrencySymbol } from '../../utils'
import { unwrappedToken } from '../../utils/wrappedCurrency'
import { StyledBalanceMaxMini } from './styleds'

interface TradePriceProps {
  price?: Price
  showInverted: boolean
  setShowInverted: (showInverted: boolean) => void
}

export default function TradePrice({ price, showInverted, setShowInverted }: TradePriceProps) {
  const { chainId } = useActiveWeb3React()
  const theme = useContext(ThemeContext)

  const formattedPrice = showInverted ? price?.toSignificant(6) : price?.invert()?.toSignificant(6)

  // Unwrap tokens to show native currency (CFX) instead of WETH
  const baseCurrency = price?.baseCurrency instanceof Token ? unwrappedToken(price.baseCurrency) : price?.baseCurrency
  const quoteCurrency =
    price?.quoteCurrency instanceof Token ? unwrappedToken(price.quoteCurrency) : price?.quoteCurrency
  const baseSymbol = getCurrencySymbol(baseCurrency, chainId)
  const quoteSymbol = getCurrencySymbol(quoteCurrency, chainId)

  const show = Boolean(price?.baseCurrency && price?.quoteCurrency)
  const label = showInverted ? `${quoteSymbol} per ${baseSymbol}` : `${baseSymbol} per ${quoteSymbol}`

  return (
    <Text
      fontWeight={500}
      fontSize={14}
      color={theme.text2}
      style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}
    >
      {show ? (
        <>
          {formattedPrice ?? '-'} {label}
          <StyledBalanceMaxMini onClick={() => setShowInverted(!showInverted)}>
            <Repeat size={14} />
          </StyledBalanceMaxMini>
        </>
      ) : (
        '-'
      )}
    </Text>
  )
}
